import Vue from "vue";

import "normalize.css/normalize.css"; // A modern alternative to CSS resets

import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import locale from "element-ui/lib/locale/lang/zh-CN"; // lang i18n
import VCharts from "v-charts";

import "@/styles/index.scss"; // global css

import App from "./App";
import router from "./router";
import store from "./store";

import { download } from '@/utils/request'

import "@/icons"; // icon
import "@/permission"; // permission control
import { registerFilters } from "@/utils/filters"; // Vue filter

Vue.use(ElementUI, { locale });
Vue.use(VCharts);
import directive from "./directive"; // directive
Vue.use(directive);

Vue.prototype.download = download

Vue.config.productionTip = false;

registerFilters();

new Vue({
  el: "#app",
  router,
  store,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js